import { defineStore } from 'pinia';
import axios from 'axios';

export const useUserStore = defineStore('user', {
  state: () => ({
    users: [],
    apiBaseUrl: 'https://tegiot.inl.int/api',
    authToken: '8AtjHRYe0bW6ah85NioxbOEECTJgiWrJ91lfBTy6', 
  }),
  actions: {
    async fetchUsers() {
      try {
        const response = await axios.get(`${this.apiBaseUrl}/users`, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.authToken}`, 
          },
        });
        this.users = response.data; 
      } catch (error) {
        if (error.response && error.response.data) {
          throw new Error(error.response.data);
        } else {
          throw new Error("An unknown error occurred while fetching users.");
        }
      }
    },
  },
  getters: {
    getUsers: (state) => state.users,
    getApiBaseUrl: (state) => state.apiBaseUrl,
  },
});